@if (visible) {
  <div class="srm-overlay" (click)="onOverlayClick($event)" role="presentation">
    <div
      class="srm-modal"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="'srm-title'"
      (click)="$event.stopPropagation()"
    >
      <header class="srm-header">
        <h2 class="srm-title" id="srm-title">{{ title }}</h2>
        <button type="button" class="srm-close" aria-label="Close" (click)="onCancel()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path
              d="M12 4L4 12M4 4L12 12"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </header>

      <div class="srm-body">
        <div class="srm-grid srm-grid--2">
          <div class="srm-field">
            <label class="srm-label" for="srm-report-type">
              Report type<span class="srm-req" aria-hidden="true">*</span>
            </label>
            <mat-select
              class="form-select srm-dropdown"
              id="srm-report-type"
              [(ngModel)]="draft.report_type"
              name="reportType"
              placeholder="Select report type"
              (selectionChange)="onReportTypeChange()"
            >
              <mat-option *ngFor="let reportType of reportTypeOptions" [value]="reportType.value">
                <span>{{ reportType.label }}</span>
              </mat-option>
            </mat-select>
          </div>

          <div class="srm-field">
            <label class="srm-label" id="srm-location-label">
              Location<span class="srm-req" aria-hidden="true">*</span>
            </label>
            <app-checkbox-multi-dropdown
              appearance="input"
              ariaLabel="Location"
              ariaLabelledBy="srm-location-label"
              [options]="locationOptions"
              [selectedIds]="draft.location_ids"
              allOptionLabel="All locations"
              [multipleSelectionText]="'{{count}} Locations'"
              (selectedIdsChange)="onLocationIdsChange($event)"
            ></app-checkbox-multi-dropdown>
          </div>
        </div>

        <div class="srm-field">
          <label class="srm-label" id="srm-employees-label">
            Employees<span class="srm-req" aria-hidden="true">*</span>
          </label>
          <app-checkbox-multi-dropdown
            appearance="input"
            ariaLabel="Employees"
            ariaLabelledBy="srm-employees-label"
            [options]="employeeOptions"
            [selectedIds]="draft.employee_ids"
            [disabled]="hasNoEmployees"
            [label]="
              employeesLoading
                ? 'Loading employees…'
                : hasNoEmployees
                  ? 'No employees'
                  : 'All employees'
            "
            allOptionLabel="All employees"
            [multipleSelectionText]="'{{count}} Employees'"
            (selectedIdsChange)="onEmployeeIdsChange($event)"
          ></app-checkbox-multi-dropdown>
          @if (hasNoEmployees) {
            <p class="srm-hint" role="status">No employees found for the selected location.</p>
          }
        </div>

        <div class="srm-grid srm-grid--2">
          <div class="srm-field">
            <label class="srm-label" for="srm-frequency">
              Frequency<span class="srm-req" aria-hidden="true">*</span>
            </label>
            <mat-select
              class="form-select srm-dropdown"
              id="srm-frequency"
              [(ngModel)]="draft.frequency_kind"
              name="frequency"
              placeholder="Select frequency"
              (selectionChange)="onFrequencyChange()"
            >
              <mat-option *ngFor="let frequency of frequencyOptions" [value]="frequency.value">{{
                frequency.label
              }}</mat-option>
            </mat-select>
          </div>

          @if (showDeliveryTime) {
            <div class="srm-field">
              <label class="srm-label" for="srm-delivery-time">
                Delivery time<span class="srm-req" aria-hidden="true">*</span>
              </label>
              <input
                id="srm-delivery-time"
                class="srm-input"
                type="time"
                name="deliveryTime"
                [(ngModel)]="draft.delivery_time"
                required
              />
            </div>
          }
        </div>

        @if (draft.frequency_kind === 'weekly') {
          <div class="srm-field">
            <label class="srm-label" for="srm-weekday">
              Weekday<span class="srm-req" aria-hidden="true">*</span>
            </label>
            <mat-select
              class="form-select srm-dropdown"
              id="srm-weekday"
              [(ngModel)]="draft.weekday"
              name="weekday"
              placeholder="Select weekday"
            >
              <mat-option *ngFor="let weekday of weekdayOptions" [value]="weekday.value">{{
                weekday.label
              }}</mat-option>
            </mat-select>
          </div>
        }

        @if (draft.frequency_kind === 'monthly') {
          <div class="srm-field">
            <label class="srm-label" for="srm-month-day">
              Day of month<span class="srm-req" aria-hidden="true">*</span>
            </label>
            <mat-select
              class="form-select srm-dropdown"
              id="srm-month-day"
              [(ngModel)]="draft.month_day"
              name="monthDay"
              placeholder="Select day"
            >
              <mat-option *ngFor="let monthDay of monthDayOptions" [value]="monthDay.value">{{
                monthDay.label
              }}</mat-option>
            </mat-select>
          </div>
        }

        @if (showSeparateMailsToggle) {
          <div class="srm-option-card">
            <div class="srm-option-card__copy">
              <span class="srm-option-card__title" id="srm-individual-label">
                Separate files for each employee
              </span>
              <p class="srm-option-card__desc" id="srm-individual-hint">
                Recipients get one email with a separate attachment per employee.
              </p>
            </div>
            <label class="srm-switch">
              <input
                type="checkbox"
                class="srm-switch__input"
                [(ngModel)]="draft.individual_reports"
                name="individualReports"
                aria-labelledby="srm-individual-label"
                aria-describedby="srm-individual-hint"
              />
              <span class="srm-switch__track" aria-hidden="true">
                <span class="srm-switch__thumb">
                  <svg
                    class="srm-switch__check"
                    width="10"
                    height="8"
                    viewBox="0 0 10 8"
                    fill="none"
                  >
                    <path
                      d="M1 4L3.5 6.5L9 1"
                      stroke="currentColor"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </span>
            </label>
          </div>
        }

        <div class="srm-grid srm-grid--2">
          <div class="srm-field">
            <label class="srm-label" for="srm-format">
              Format<span class="srm-req" aria-hidden="true">*</span>
            </label>
            <mat-select
              class="form-select srm-dropdown"
              id="srm-format"
              [(ngModel)]="draft.format"
              name="format"
              placeholder="Select format"
            >
              <mat-option *ngFor="let format of formatOptions" [value]="format.value">{{
                format.label
              }}</mat-option>
            </mat-select>
          </div>

          <div class="srm-field">
            <label class="srm-label" id="srm-start-date-label">
              Start date<span class="srm-req" aria-hidden="true">*</span>
            </label>
            <app-wi-date-range-picker
              mode="date"
              ariaLabel="Start date"
              ariaLabelledBy="srm-start-date-label"
              [selectedDate]="draft.start_date"
              [showActions]="false"
              placeholder="Select start date"
              (dateChange)="onStartDateChange($event)"
            ></app-wi-date-range-picker>
          </div>
        </div>

        <div class="srm-field">
          <label class="srm-label">
            Recipient emails<span class="srm-req" aria-hidden="true">*</span>
          </label>
          <div class="srm-recipients">
            @for (email of draft.recipient_emails; track trackByIndex($index); let i = $index) {
              <div class="srm-recipient-row">
                <input
                  class="srm-input"
                  type="email"
                  [name]="'recipient-' + i"
                  [(ngModel)]="draft.recipient_emails[i]"
                  [attr.aria-label]="'Recipient email ' + (i + 1)"
                  placeholder="name@company.com"
                />
                <button
                  type="button"
                  class="srm-icon-btn"
                  [attr.aria-label]="'Remove recipient ' + (i + 1)"
                  (click)="removeRecipient(i)"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <path
                      d="M3.333 4.667h9.334M6 4.667V3.333h4v1.334M6.667 7.333v4M9.333 7.333v4M4.667 4.667l.666 8h5.334l.666-8"
                      stroke="currentColor"
                      stroke-width="1.3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            }
          </div>
          <button type="button" class="srm-add-link" (click)="addRecipient()">
            <span aria-hidden="true">+</span>
            Add recipient
          </button>
        </div>
      </div>

      <footer class="srm-footer">
        <button type="button" class="srm-btn srm-btn--ghost" (click)="onClear()">Clear</button>
        <div class="srm-footer__actions">
          <button type="button" class="srm-btn srm-btn--secondary" (click)="onCancel()">
            Cancel
          </button>
          <button
            type="button"
            class="srm-btn srm-btn--primary"
            [disabled]="!canSave"
            (click)="onSave()"
          >
            Save
          </button>
        </div>
      </footer>
    </div>
  </div>
}
